<div
  *ngIf="platform === PlatformEnum.desktop"
  class="desktop-container"
  [class.warning-msg]="
    product?.drawerMsg?.isWarning || product?.productCardWarningMsg?.primaryText
  "
  [class.message]="
    !!product?.drawerMsg?.message && !product.drawerMsg?.isWarning
  "
>
  <app-product-card-drawer
    [drawerMessage]="!product?.hasAlternative ? product?.drawerMsg : undefined"
    [warningMessage]="product?.productCardWarningMsg"
    (infoIconClickEmitter)="handleProductImageClick()"
  >
  </app-product-card-drawer>

  <div class="card">
    <div class="image-container" (click)="handleProductImageClick()">
      <img
        *ngIf="!!product?.smallImageUrl"
        src="{{ product?.smallImageUrl }}"
      />
      <ion-icon
        *ngIf="!product?.smallImageUrl"
        data-cy="product-card-no-image-icon"
        class="no-image"
        name="restaurant"
      ></ion-icon>
    </div>
    <div class="brand">{{ product?.summary?.brand | lowercase }}</div>
    <a class="product-title" (click)="handleProductImageClick()">
      {{ product?.summary?.productDescTxtl | lowercase }}
    </a>

    <div class="product-number-size">
      <p>#{{ product?.summary?.productNumber }}</p>
      <img src="assets/images/separator.png" />
      <p>{{ product?.summary?.salesPackSize }}</p>
    </div>
    <div
      *ngIf="!!product?.pricePerPortion || !!product?.detail?.servingsPerCase"
      class="price-per-portion-servings-per-case"
    >
      <p *ngIf="!!product?.pricePerPortion">
        {{ product?.pricePerPortion }}
      </p>
      <img
        *ngIf="!!product?.detail?.servingsPerCase && !!product?.pricePerPortion"
        src="assets/images/separator.png"
      />
      <p *ngIf="!!product?.detail?.servingsPerCase">
        {{ product?.detail?.servingsPerCase }}
        {{ 'i18n.betterBuys.servingsPerCase' | translate }}
      </p>
    </div>

    <div class="pricing-row">
      <app-price-display
        [disabled]="pricingDisabled"
        [price]="product?.pricing"
        [displayCases]="true"
        [catchWeightFlag]="product?.summary?.catchWeightFlag"
        [priceUom]="product?.summary?.priceUom"
        [addMargin]="false"
        [specialOrder]="product?.inventory?.isSpecialOrder"
      ></app-price-display>
      <span *ngIf="product?.summary?.breakable">/</span>
      <app-price-display
        *ngIf="product?.summary?.breakable"
        [disabled]="pricingDisabled"
        [price]="product?.pricing"
        [displayCases]="false"
        [catchWeightFlag]="product?.summary?.catchWeightFlag"
        [priceUom]="product?.summary?.priceUom"
        [addMargin]="false"
      ></app-price-display>
    </div>

    <div *ngIf="product?.productTags?.length > 0" class="pills-row">
      <app-usf-product-tag-list
        [tagList]="product?.productTags"
        [maxTags]="1"
        [product]="product"
        [allTagsClickable]="true"
      ></app-usf-product-tag-list>
    </div>
    <ion-button
      *ngIf="showKeepProductButton"
      class="usf-outline-green-button"
      (click)="handleKeepProductClick()"
    >
      {{ 'i18n.betterBuys.keepThisProduct' | translate }}
    </ion-button>
  </div>
</div>

<div
  *ngIf="platform !== PlatformEnum.desktop"
  class="touch-container"
  [class.warning-msg]="
    product?.productCardWarningMsg?.display || product?.drawerMsg?.isWarning
  "
>
  <app-product-card-drawer
    [drawerMessage]="!product?.hasAlternative ? product?.drawerMsg : undefined"
    [warningMessage]="product?.productCardWarningMsg"
    (infoIconClickEmitter)="handleProductImageClick()"
  >
  </app-product-card-drawer>
  <div class="card">
    <div class="top-row">
      <div
        class="image-container"
        [class.is-mobile]="platform === PlatformEnum.mobile"
        (click)="handleProductImageClick()"
      >
        <img
          *ngIf="!!product?.smallImageUrl"
          src="{{ product?.smallImageUrl }}"
        />
        <ion-icon
          *ngIf="!product?.smallImageUrl"
          data-cy="product-card-no-image-icon"
          class="no-image"
          name="restaurant"
        ></ion-icon>
      </div>

      <div
        class="product-info"
        [class.is-mobile]="platform === PlatformEnum.mobile"
      >
        <div class="brand">{{ product?.summary?.brand | lowercase }}</div>
        <a class="product-title" (click)="handleProductImageClick()">
          {{ product?.summary?.productDescTxtl | lowercase }}
        </a>

        <div class="product-number-size">
          <p>#{{ product?.summary?.productNumber }}</p>
          <img src="assets/images/separator.png" />
          <p>{{ product?.summary?.salesPackSize }}</p>
          <img
            *ngIf="
              !!product?.pricePerPortion && platform === PlatformEnum.tablet
            "
            src="assets/images/separator.png"
          />
          <p
            *ngIf="
              !!product?.pricePerPortion && platform === PlatformEnum.tablet
            "
          >
            {{ product?.pricePerPortion }}
          </p>
          <img
            *ngIf="
              !!product?.detail?.servingsPerCase &&
              platform === PlatformEnum.tablet
            "
            src="assets/images/separator.png"
          />
          <p
            *ngIf="
              !!product?.detail?.servingsPerCase &&
              platform === PlatformEnum.tablet
            "
          >
            {{ product?.detail?.servingsPerCase }}
            {{ 'i18n.betterBuys.servingsPerCase' | translate }}
          </p>
        </div>
        <div
          *ngIf="
            (!!product?.pricePerPortion ||
              !!product?.detail?.servingsPerCase) &&
            platform === PlatformEnum.mobile
          "
          class="price-per-portion-servings-per-case"
        >
          <p *ngIf="!!product?.pricePerPortion">
            {{ product?.pricePerPortion }}
          </p>
          <img
            *ngIf="
              !!product?.detail?.servingsPerCase && !!product?.pricePerPortion
            "
            src="assets/images/separator.png"
          />
          <p *ngIf="!!product?.detail?.servingsPerCase">
            {{ product?.detail?.servingsPerCase }}
            {{ 'i18n.betterBuys.servingsPerCase' | translate }}
          </p>
        </div>

        <div
          *ngIf="platform === PlatformEnum.mobile"
          class="mobile-pricing bold"
        >
          <app-price-display
            [disabled]="pricingDisabled"
            [price]="product?.pricing"
            [displayCases]="true"
            [catchWeightFlag]="product?.summary?.catchWeightFlag"
            [priceUom]="product?.summary?.priceUom"
            [addMargin]="false"
            [specialOrder]="product?.inventory?.isSpecialOrder"
          ></app-price-display>
          <span *ngIf="product?.summary?.breakable">/</span>
          <app-price-display
            *ngIf="product?.summary?.breakable"
            [disabled]="pricingDisabled"
            [price]="product?.pricing"
            [displayCases]="false"
            [catchWeightFlag]="product?.summary?.catchWeightFlag"
            [priceUom]="product?.summary?.priceUom"
            [addMargin]="false"
          ></app-price-display>
        </div>

        <div *ngIf="platform === PlatformEnum.tablet" class="tablet-pills">
          <app-usf-product-tag-list
            [tagList]="product?.productTags"
            [maxTags]="5"
            [product]="product"
            [allTagsClickable]="true"
          ></app-usf-product-tag-list>
        </div>
      </div>

      <div *ngIf="platform === PlatformEnum.tablet" class="tablet-right-col">
        <div class="tablet-pricing">
          <app-price-display
            [disabled]="pricingDisabled"
            [price]="product?.pricing"
            [displayCases]="true"
            [catchWeightFlag]="product?.summary?.catchWeightFlag"
            [priceUom]="product?.summary?.priceUom"
            [addMargin]="false"
            [specialOrder]="product?.inventory?.isSpecialOrder"
          ></app-price-display>
          <span *ngIf="product?.summary?.breakable">/</span>
          <app-price-display
            *ngIf="product?.summary?.breakable"
            [disabled]="pricingDisabled"
            [price]="product?.pricing"
            [displayCases]="false"
            [catchWeightFlag]="product?.summary?.catchWeightFlag"
            [priceUom]="product?.summary?.priceUom"
            [addMargin]="false"
          ></app-price-display>
        </div>
        <div class="tablet-keep-product-btn">
          <ion-button
            *ngIf="showKeepProductButton"
            class="usf-outline-green-button"
            (click)="handleKeepProductClick()"
          >
            {{ 'i18n.betterBuys.keepThisProduct' | translate }}
          </ion-button>
        </div>
      </div>
    </div>

    <div *ngIf="platform === PlatformEnum.mobile" class="mobile-bottom-row">
      <div class="mobile-tags">
        <app-usf-product-tag-list
          [tagList]="product?.productTags"
          [maxTags]="2"
          [product]="product"
          [allTagsClickable]="true"
        ></app-usf-product-tag-list>
      </div>

      <div class="mobile-keep-product-btn">
        <ion-button
          *ngIf="showKeepProductButton"
          class="usf-outline-green-button"
          (click)="handleKeepProductClick()"
        >
          {{ 'i18n.betterBuys.keepThisProduct' | translate }}
        </ion-button>
      </div>
    </div>
  </div>
</div>
